<script>
  import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "imgEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        imgDirectionList: [
          {
            value: '0',
            name: '0度'
          },
          {
            value: '90',
            name: '90度'
          },
          {
            value: '180',
            name: '180度'
          },
          {
            value: '270',
            name: '270度'
          }
        ],
        formList: [
          'ImgForm',
        ],
        ruleList: [
          {
          }
        ]
      }
    },
    computed: {
      specificForms() {
        return (
          <div class="specificForms">
              <el-collapse-item class="specificForm" title="图片效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="ImgForm" props={{model: this.newSettings}} ref="ImgForm" label-style={this.formLabelStyle}
                             hide-required-asterisk={true}>
                      <el-form-item label="更换图片" label-position={this.labelPosition}>
                        <el-button size="small" type="primary" icon="el-icon-edit" circle
                           {...{nativeOn: {
                               'click': this.handleChangeImageUrl
                             }}}
                        />
                      </el-form-item>
                      <el-form-item label="图片旋转" prop="imgDirection" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                            value: this.newSettings.imgDirection,
                            type: 'radio',
                            radioList: this.imgDirectionList,
                            varList: this.varList,
                            varJson: this.varJson,
                            showEditButton: false,
                          }}}{...{on: {
                            'input': val=>{
                              this.imgDirectionChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>
          </div>
        )
      }
    },
    methods:{
      imgDirectionChange(val){
        // this.styleMergeObj = {
        //   ...this.styleMergeObj,
        //   width : this.wrapperStyle.width,
        //   height : this.wrapperStyle.height,
        // }
        // this.wrapperStyleMergeObj = {
        //   ...this.wrapperStyleMergeObj,
        //   'transform' : 'rotate(' + val + 'deg)',
        // }
        if (val === "0" && (this.newSettings.imgDirection == "90" || this.newSettings.imgDirection == "270")) {
          //长宽对调
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(0deg)'
        }else if(val === "0" && (this.newSettings.imgDirection == "0" || this.newSettings.imgDirection == "180")){
          this.newSettings.transform = 'rotate(0deg)'
        }else if (val === "90" && (this.newSettings.imgDirection == "0" || this.newSettings.imgDirection == "180")) {
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(90deg)'
        }else if (val === "90" && (this.newSettings.imgDirection == "90" || this.newSettings.imgDirection == "270")) {
          this.newSettings.transform = 'rotate(90deg)'
        }else if (val === "180" && (this.newSettings.imgDirection == "90" || this.newSettings.imgDirection == "270")) {
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(180deg)'
        }else if (val === "180" && (this.newSettings.imgDirection == "0" || this.newSettings.imgDirection == "180")) {
          this.newSettings.transform = 'rotate(180deg)'
        }else if(val === "270" && (this.newSettings.imgDirection == "0" || this.newSettings.imgDirection == "180")){
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(270deg)'
        }else if(val === "270" && (this.newSettings.imgDirection == "90" || this.newSettings.imgDirection == "270")){
          this.newSettings.transform = 'rotate(270deg)'
        }

        this.newSettings.imgDirection = val
      },
      imgState(val,attr){
        this.$set(this.newSettings, attr, val)
      },
      //用户发起修改图片url请求
      //将该组件的 id 传递到TheCreate页面中，激活该页面的修改图片组件
      handleChangeImageUrl(){
        this.$emit("changeImageUrl", this.editingId)
      }
    }
  }
</script>

<style lang="less">
  .imgEditor {
    .singleSelect {
      height: 30px;
      line-height: 30px;
      width: 100%;
      border-radius: 5px;
      padding: 0 10px;
    }
  }
</style>

